const fonts = {
  body: "Arimo",
};
export default fonts;
